/** Days until the period ends at/below which we surface urgency indicators. */
export const ATTENTION_THRESHOLD_DAYS = 30;

export interface LicenseUrgency {
  /** Whole days remaining including the end day itself; 0 once the period is over. */
  daysLeft: number;
  attentionRequired: boolean;
  /** True when the period's end date is already past — render "Period ended", not "0 days left". */
  periodEnded: boolean;
}

/** Days remaining in the reporting period + whether to flag urgency (not compliant, ending soon). */
export function getUrgency(periodEnd: string, isCompliant: boolean, now: Date = new Date()): LicenseUrgency {
  // Period boundaries are date-only values pinned to UTC (stored as 23:59:59Z).
  // Compare whole UTC calendar days — the same convention as the requirement
  // form's todayUtcDate() check — so daysLeft can't drift a day with the
  // viewer's timezone or time of day.
  const end = new Date(periodEnd);
  const endDay = Date.UTC(end.getUTCFullYear(), end.getUTCMonth(), end.getUTCDate());
  const nowDay = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
  const dayDiff = Math.round((endDay - nowDay) / 86_400_000);
  const periodEnded = dayDiff < 0;
  // The end day itself still counts: "1 day left" on the final day.
  const daysLeft = Math.max(0, dayDiff + 1);
  return {
    daysLeft,
    attentionRequired: !isCompliant && daysLeft <= ATTENTION_THRESHOLD_DAYS,
    periodEnded,
  };
}
